export default __webpack_public_path__ + "static/media/aethenos_logo.1e69b289.png";